const UNIT_RE = /^(-?\d+|%|px|em|rem|vw|vh|cm|mm|in|pt|pc|ex|ch|vmin|vmax|fr)|auto$/;
export function dimension(value) {
  if (typeof value === 'number') {
    return `${value}px`;
  }

  if (UNIT_RE.test(value)) {
    return value;
  }

  return `var(--${value})`;
}